import React, { useState } from 'react';
import { HiPaperAirplane, HiEnvelope, HiChatBubbleLeftRight } from 'react-icons/hi2';
import { useScrollReveal } from '../utils/useScrollReveal';
import './Contact.css';

export default function Contact() {
  const [status, setStatus] = useState('idle'); // idle | sending | success | error
  const [infoRef, infoVisible] = useScrollReveal();
  const [formRef, formVisible] = useScrollReveal();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    const form = e.target;
    const data = new FormData(form);

    try {
      const res = await fetch('https://formspree.io/f/xnjorpbr', {
        method: 'POST',
        body: data,
        headers: { Accept: 'application/json' },
      });

      if (res.ok) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="contact section" id="contact">
      <div className="container">
        <div className="contact__layout">
          <div ref={infoRef} className={`contact__info reveal-left ${infoVisible ? 'is-revealed' : ''}`}>
            <span className="section-label">Get in Touch</span>
            <h2 className="section-title">Let's Create Something<br />Amazing Together</h2>
            <p className="section-subtitle">
              Have a custom project? Need screenshots for multiple apps?
              Drop us a message and we'll get back to you within a few hours.
            </p>

            <div className="contact__methods">
              <div className="contact__method">
                <div className="contact__method-icon">
                  <HiEnvelope />
                </div>
                <div>
                  <strong>Email Us</strong>
                  <span>hello@storeshot.io</span>
                </div>
              </div>
              <div className="contact__method">
                <div className="contact__method-icon">
                  <HiChatBubbleLeftRight />
                </div>
                <div>
                  <strong>Response Time</strong>
                  <span>Usually within 2 hours</span>
                </div>
              </div>
            </div>
          </div>

          <div ref={formRef} className={`contact__form-wrapper reveal-right ${formVisible ? 'is-revealed' : ''}`}>
            {status === 'success' ? (
              <div className="contact__success">
                <div className="contact__success-icon">
                  <HiPaperAirplane />
                </div>
                <h3>Message Sent!</h3>
                <p>Thanks for reaching out. We'll get back to you within a few hours.</p>
                <button className="btn btn-outline" onClick={() => setStatus('idle')}>
                  Send Another Message
                </button>
              </div>
            ) : (
              <form className="contact__form" onSubmit={handleSubmit}>
                <div className="contact__form-row">
                  <div className="contact__field">
                    <label htmlFor="name">Name</label>
                    <input type="text" id="name" name="name" placeholder="Your name" required />
                  </div>
                  <div className="contact__field">
                    <label htmlFor="email">Email</label>
                    <input type="email" id="email" name="email" placeholder="you@example.com" required />
                  </div>
                </div>

                <div className="contact__field">
                  <label htmlFor="platform">Platform</label>
                  <select id="platform" name="platform" required>
                    <option value="">Select platform(s)</option>
                    <option value="ios">iOS (iPhone)</option>
                    <option value="ipad">iPad</option>
                    <option value="android">Android</option>
                    <option value="ios+ipad">iOS + iPad</option>
                    <option value="ios+android">iOS + Android</option>
                    <option value="all">All Platforms</option>
                  </select>
                </div>

                <div className="contact__field">
                  <label htmlFor="message">Tell us about your app</label>
                  <textarea
                    id="message"
                    name="message"
                    placeholder="Describe your app, your brand style, and any specific requirements..."
                    rows={5}
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary btn-lg contact__submit"
                  disabled={status === 'sending'}
                >
                  {status === 'sending' ? 'Sending...' : 'Send Message'}
                  <HiPaperAirplane />
                </button>

                {status === 'error' && (
                  <p className="contact__error">Something went wrong. Please try again or email us directly.</p>
                )}
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
